import React from 'react';
import DailyTrendWidget from './Components/DailyTrendWidget/DailyTrendWidget';
import EnforcementScansWidget from './Components/EnforcementScansWidget/EnforcementScansWidget';
import DriverTypesWidget from './Components/DriverTypesWidget/DriverTypesWidget';
import styles from './StatsSection.module.css';

type StatsSectionProps = {
    shouldRender: boolean;
    spotUuid: string;
    timezone: string;
    isDemoMode: boolean;
};

function StatsSection({ shouldRender, spotUuid, timezone, isDemoMode }: StatsSectionProps): JSX.Element | null {
    if (!shouldRender) {
        return null;
    }

    return (
        <section className={styles.section} data-testid="visibility-stats-section">
            <div className={styles.middleRow} data-testid="visibility-middle-row">
                <DailyTrendWidget spotUuid={spotUuid} timezone={timezone} isDemoMode={isDemoMode} />
            </div>
            <div className={styles.bottomRow} data-testid="visibility-bottom-row">
                <div className={styles.widgetSlot}>
                    <EnforcementScansWidget spotUuid={spotUuid} isDemoMode={isDemoMode} />
                </div>
                <div className={styles.widgetSlot}>
                    <DriverTypesWidget spotUuid={spotUuid} isDemoMode={isDemoMode} />
                </div>
            </div>
        </section>
    );
}

export default StatsSection;
